import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PurchaseOrderLookupComponent } from './purchase-order-lookup.component';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule
  ],
  declarations: [PurchaseOrderLookupComponent],
  exports: [PurchaseOrderLookupComponent]
})
export class PurchaseOrderLookupModule { }
